import React, { useEffect, useState, useRef, Fragment } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { PageHeader } from "@ant-design/pro-components";
import {
    Layout,
    Tabs,
    Button,
    Statistic,
    Descriptions,
    List,
    Modal,
    Tooltip,
    Skeleton,
    Input,
    Form,
    Select,
    Table,
    Row,
    Col,
    Empty,
    Dropdown,
    Tag,
    Radio,
    notification,
    Space,
    Checkbox,
    Avatar,
    Divider,
    Switch,
    Card,
    InputNumber,
} from "antd";
import _ from "lodash";
import moment from "moment";
import "moment/locale/pt-br";
import {
    EditOutlined,
    DeleteOutlined,
    MinusCircleOutlined,
    ExclamationCircleOutlined,
    WarningOutlined,
    MenuOutlined,
    PlusOutlined,
    CloudSyncOutlined,
    FunctionOutlined,
} from "@ant-design/icons";
import { DndContext } from "@dnd-kit/core";
import { restrictToVerticalAxis } from "@dnd-kit/modifiers";
import {
    SortableContext,
    useSortable,
    verticalListSortingStrategy,
} from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

/**
 * Components
 */
import TopBar from "components/NavBar/TopBar";
import DrawerSider from "components/NavBar/DrawerSider";
import CheckBoxForm from "components/Forms/SignIn/Fields/New/CheckBoxForm";
import { LayoutTopSide } from "components/NavBar/styles";
import TreeTransfer from "components/Forms/SignIn/Fields/Ref/TransferTree.ref";
import { default as TreeTransferLookup } from "components/Forms/SignIn/Fields/Lookup/TransferTree.lookup";


/**
 * Actions
 */
import {
    dropObj,
    dropObjField,
    dropArchivedObjField,
    editfieldObj,
    addFields,
    allFieldsByName,
    alterpos,
    allCategoriesObj,
    allCategoriesOfObj,
    pushCategoryInObj,
    pullCategoryInObj,
    findObject,
    changeDescriptionInObj,
    getRefFieldsByData,
    getMetadataOfObj,
    verifyCanDeleteField, changeConfigSyncInObj, changeFieldDateMainInObj,
    getQuantityFieldsNested,
    getReferencedFields,
    editValidationObj
} from "auth/actions/objActions";

/**
 * Utils
 */
import {
    handleCkHidden,
    handleRfHidden,
    handleDtHidden,
    handleLkHidden,
    handleDtRules,
    removeRef,
    removeLk, handleFormulaHidden,
} from "utils/form-params";
import { importApi } from "services/actions/import";
import uuid from "react-uuid";
import { useSelector } from "react-redux";
import { Formula } from "../../../components/Forms/SignIn/Fields/Formula";
import { validateFormula } from "../../../hooks/dataOfForm";
import { checkPermission, getAllPermissionsByUnit } from "../../../utils/permission";
import ConflictTable from "components/Utils/conflictTable";
import ReferenceFieldsRefTable from "components/Utils/referenceFieldsRef";
import { enforceParentChildOrder } from "utils/order-parent-child-fields";

/**
 * Misc
 */
const { confirm } = Modal;
const { Option, OptGroup } = Select;
export default function Details() {
    return <SortableTable />;
}
// dnd-kit: os listeners de arrasto vivem na linha (useSortable); o handle na
// célula consome-os via contexto, como no exemplo oficial do antd v5.
const RowDragContext = React.createContext({});
const DragHandle = ({ active }) => {
    const { listeners, attributes } = React.useContext(RowDragContext);
    return (
        <MenuOutlined
            {...attributes}
            {...listeners}
            style={{ cursor: "grab", color: active ? "blue" : "#999", touchAction: "none" }}
        />
    );
};

// Função de pausa assíncrona para aguardar 1 segundo
function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
}

function SortableTable() {
    const navigate = useNavigate();
    const { name, name: objFormName } = useParams();
    const user = useSelector((state) => state.session.user);
    const permissions = useSelector((state) => state.user.permissions);
    const company = useSelector((state) => state.user.company);

    const [formEditHasError, setFormEditHasError] = useState(false);
    const [formEdit] = Form.useForm();
    const [formValidation] = Form.useForm();
    const [form] = Form.useForm();
    const formValues = Form.useWatch("fields", form);
    const [formDetails, setFormDetails] = useState([]);
    const [data, setData] = useState([]);
    const [selectedItems, setSelectedItems] = React.useState([]);
    const [selectedForm, setSelectedForm] = useState([]);
    const [dataSource, setDataSource] = useState(data);
    const [editingField, setEditingField] = useState(null);
    // Snapshot imutável do campo ANTES da edição (editingField é mutado a cada
    // onChange, então não serve como "antes"). Usado no log de atividade.
    const originalEditingFieldRef = React.useRef(null);
    const [addisVisible, setaddisVisible] = useState(false);
    const [isEditing, setisEditing] = useState(false);
    const [isEditingValidationForm, setIsEditingValidationForm] = useState(false);
    const [isHaveData, setIsHaveData] = useState(false);
    const [ischeckbox, setischeckbox] = useState(false);
    const [isref, setisref] = useState(false);
    const [islookup, setislookup] = useState(false);
    const [visible, setVisible] = useState(false);
    const [permissionsFromForm, setPermissionsFromForm] = useState(null);


    const [isModalCanNotDeleteVisible, setModalCanNotDeleteVisible] = useState(false);
    const [fieldCanNotDelete, setFieldCanNotDelete] = useState([]);
    const [fieldOrFOrmCanNotDelete, setFieldOrFOrmCanNotDelete] = useState(1);
    // editar formulário
    const [isEditingForm, setisEditingForm] = useState(false);
    const [category, setCategory] = useState([]);
    const [categories, setCategories] = useState([]);
    const [wasUpdated, setWasUpdated] = useState(false);
    const [canSaveGet, setCanSaveGet] = useState(true);
    const [canSaveCheck, setCanSaveCheck] = useState(true);

    // Quantidade de fields nested 
    const [quantityFieldNestedValue, setQuantityFieldNestedValue] = useState(0);
    const [quantityFieldNestedBin, setQuantityFieldNestedBin] = useState(0);
    const quantityMaxFieldsNested = 100;

    // importações
    const [isImportsForm, setIsImportsForm] = useState(false);
    const [isEditingSyncConfig, setIsEditingSyncConfig] = useState(false);
    const [isEditingFieldDateMain, setIsEditingFieldDateMain] = useState(false);
    const [fieldDateMain, setFieldDateMain] = useState(null);
    const [syncConfig, setSyncConfig] = useState({
        value: 0,
        valueType: null,
        fullSync: true,
    });
    const [filesHistory, setFilesHistory] = useState([]);

    /**
     * Traduz nome do tipo do campo
     * @param {*} type
     * @returns
     */
    function getFieldType(type) {
        if (type || type) {
            switch (type) {
                case "pieSimple":
                    return "Gráfico de setores circular";
                case "Text":
                    return "Texto";
                case "Numeric":
                    return "Numérico";
                case "Date":
                    return "Data";
                case "Time":
                    return "Tempo";
                case "uniqueSelection":
                    return "Seleção única";
                case "multipleSelection":
                    return "Múltipla seleção";
                case "refUniqueSelection":
                    return "Seleção única referenciada";
                case "refMultipleSelection":
                    return "Múltipla seleção referenciada";
                case "refLookup":
                    return "Consulta";
                case "formula":
                    return "Fórmula";
                case "label":
                    return "Label";
                default:
                    return "Padrão";
            }
        }
    }

    /**
     * Tenta encontrar o nome do campo com base no ID do filho
     * @param {*} id
     * @returns
     */
    function findFieldName(fields, id) {
        for (const father of fields) {
            if (father.checkValueIn) {
                for (const child of father.checkValueIn) {
                    if (child.field === id) {
                        return `(${father.field.replace(" (Arquivado)", "")})`;
                    }
                }
            }
        }
        return "N/A";
    }

    /**
     * Tabela de formulários
     * @returns
     */
    const hasPermissionToEditField = company && formDetails.length > 0 && checkPermission(permissionsFromForm, 'EDIT_FIELD_IN_FORM', company.unitId, 'form', formDetails[0]._id)
    const hasPermissionToRemoveField = company && formDetails.length > 0 && checkPermission(permissionsFromForm, 'DELETE_FIELD_IN_FORM', company.unitId, 'form', formDetails[0]._id)
    const hasPermissionToOrderFieldsInForm = company && formDetails.length > 0 && checkPermission(permissionsFromForm, 'ORDER_FIELDS_IN_FORM', company.unitId, 'form', formDetails[0]._id)
    const hasPermissionToEditForm = company && formDetails.length > 0 && checkPermission(permissionsFromForm, 'EDIT_FORM', company.unitId, 'form', formDetails[0]._id)
    const hasPermissionToDeleteForm = company && formDetails.length > 0 && checkPermission(permissionsFromForm, 'DELETE_FORM', company.unitId, 'form', formDetails[0]._id)
    const hasPermissionToImportDataInForm = company && formDetails.length > 0 && checkPermission(permissionsFromForm, 'IMPORT_DATA_IN_FORM', company.unitId, 'form', formDetails[0]._id)
    const hasPermissionToViewDataArchivedInForm = company && formDetails.length > 0 && checkPermission(permissionsFromForm, 'VIEW_DATA_ARCHIVED_FROM_FORM', company.unitId, 'form', formDetails[0]._id)
    const getColumns = () => {
        return [
            ...(hasPermissionToOrderFieldsInForm ? [{
                title: "Posição",
                dataIndex: "",
                width: 30,
                className: "drag-visible",
                render: (d, dd, i) => (
                    <>
                        <DragHandle active={selectedItems.includes(i)} />
                    </>
                ),
            }] : []),
            {
                title: "Nome",
                dataIndex: "field",
                key: "field",
                className: "drag-visible",
                render: (text, record) => {
                    const fatherFieldName = findFieldName(dataSource, record._id);
                    if (record.isReadOnly && fatherFieldName) {
                        return (
                            <a>
                                {text} {fatherFieldName}
                            </a>
                        );
                    } else {
                        return <a>{text}</a>;
                    }
                },
            },
            {
                title: "Dica",
                dataIndex: "dica",
                key: "dica",
                render: (text) => <span>{text}</span>,
            },
            {
                title: "Tipo",
                dataIndex: "fieldtype",
                key: "fieldtype",
                className: "drag-visible",
                render: (text) => <span>{getFieldType(text)}</span>,
            },
            {
                title: "Editar",
                dataIndex: "field",
                key: "field",
                className: "drag-visible",
                render: (text, record, index) => {
                    if (!hasPermissionToEditField) {
                        return null;
                    }
                    return (
                        <div>
                            <Tooltip
                                title={
                                    record.isReadOnly || record.isDeleted || quantityFieldNestedValue == 0
                                        ? null
                                        : "Deseja alterar este campo?"
                                }
                                placement="left"
                            >
                                <Button
                                    shape="circle"
                                    icon={<EditOutlined />}
                                    onClick={() => {
                                        if (record.refFields || record.getValueOf) {
                                            if (_.size(record.refFields) > 0) {
                                                setisref(true);
                                            } else {
                                                setisref(false);
                                            }
                                            if (_.size(record.getValueOf) > 0) {
                                                setislookup(true);
                                            } else {
                                                setislookup(false);
                                            }
                                        } else {
                                            setisref(false);
                                            setislookup(false);
                                        }
                                        editField(record);
                                    }}
                                    disabled={
                                        record.isReadOnly || record.isDeleted || quantityFieldNestedValue == 0
                                            ? record.isReadOnly || record.isDeleted || quantityFieldNestedValue == 0
                                            : false
                                    }
                                    style={{ marginRight: 10 }}
                                />
                            </Tooltip>
                        </div>
                    );
                },
            },
            {
                title: "Fórmula de validação",
                dataIndex: "validation",
                key: "validation",
                className: "drag-visible",
                render: (text, record, index) => {
                    return (
                        <div>
                            <Tooltip
                                title={record.isReadOnly || record.fieldtype === "label" ? null : "Deseja editar a validação do campo?"}
                                placement="left"
                            >
                                <Button
                                    shape="circle"
                                    icon={<FunctionOutlined />}
                                    onClick={() => {
                                        setIsEditingValidationForm(true);

                                        const recordCopy = { ...record };
                                        if (recordCopy?.functionValidation?.formula) {
                                            recordCopy.functionValidation.formula = unWrapValidation(
                                                recordCopy.functionValidation.formula
                                            );
                                        }

                                        setEditingField(recordCopy);

                                        formValidation.setFieldsValue({
                                            functionValidation: recordCopy.functionValidation
                                        });
                                    }}
                                    disabled={record.isReadOnly || record.fieldtype === "label"}
                                />
                            </Tooltip>
                        </div>
                    )
                }
            },
            {
                title: "Excluir",
                dataIndex: "field",
                key: "field",
                className: "drag-visible",
                render: (text, record, index) => {
                    if (!hasPermissionToRemoveField) {
                        return null;
                    }
                    return (
                        <div>
                            <Tooltip
                                title={record.isReadOnly ? null : "Deseja remover este campo?"}
                                placement="left"
                            >
                                <Button
                                    shape="circle"
                                    icon={<DeleteOutlined />}
                                    style={{ marginRight: 10 }}
                                    onClick={() => {
                                        removeField(record);
                                    }}
                                    disabled={record.isReadOnly ? record.isReadOnly : false}
                                />
                            </Tooltip>
                        </div>
                    );
                },
            },
        ];
    };

    function isChildRecord(record) {
        return !!record.isReadOnly && dataSource.some((item) =>
            item.checkValueIn?.some((c) => c.field === record._id)
        );
    }

    const indexToBlockIndex = (blocks, flatIdx) => {
        let count = 0;
        for (let i = 0; i < blocks.length; i++) {
            count += blocks[i].length;
            if (flatIdx < count) return i;
        }
        return blocks.length - 1;
    };

    const onSortEnd = ({ oldIndex, newIndex }) => {
        if (oldIndex === newIndex) return;

        const childIds = new Set();
        dataSource.forEach((f) => {
            (f.checkValueIn || []).forEach((c) => childIds.add(c.field));
        });

        const buildBlocks = (source) => {
            const blocks = [];
            source.forEach((f) => {
                if (childIds.has(f._id)) return;
                const children = (f.checkValueIn || [])
                    .map((c) => source.find((x) => x._id === c.field))
                    .filter(Boolean);
                blocks.push([f, ...children]);
            });
            return blocks;
        };

        const blocks = buildBlocks(dataSource);
        const fromBlockIdx = indexToBlockIndex(blocks, oldIndex);
        const toBlockIdx = indexToBlockIndex(blocks, newIndex);

        if (fromBlockIdx === toBlockIdx) return;

        const newBlocks = [...blocks];
        const [moved] = newBlocks.splice(fromBlockIdx, 1);
        newBlocks.splice(toBlockIdx, 0, moved);

        const updatedValues = newBlocks
            .flat()
            .map((f, idx) => ({ ...f, index: idx }));

        alterpos({
            formName: decodeURIComponent(name),
            fields: updatedValues,
            sortedBy: user.sub,
            formId: formDetails[0]?._id,
            companyId: company.companyId,
            unitId: company.unitId,
        });

        setDataSource(updatedValues);
        setSelectedItems([]);
    };

    // dnd-kit devolve ids (rowKey="index"); converte para os índices planos
    // que o onSortEnd legado espera
    const handleDragEnd = ({ active, over }) => {
        if (!over || active.id === over.id) return;
        const oldIndex = dataSource.findIndex((x) => x.index === active.id);
        const newIndex = dataSource.findIndex((x) => x.index === over.id);
        if (oldIndex === -1 || newIndex === -1) return;
        onSortEnd({ oldIndex, newIndex });
    };

    const DraggableBodyRow = ({ className, style, ...restProps }) => {
        const index = dataSource.findIndex(
            (x) => x.index === restProps["data-row-key"]
        );
        const record = dataSource[index];

        //
        const isChild = record ? isChildRecord(record) : false;

        const {
            attributes,
            listeners,
            setNodeRef,
            transform,
            transition,
            isDragging,
        } = useSortable({
            // linhas de medição do antd não têm data-row-key
            id: restProps["data-row-key"] ?? "__placeholder__",
            disabled: isChild,
        });

        const rowStyle = {
            ...style,
            transform: CSS.Translate.toString(transform),
            transition,
            ...(isDragging ? { position: "relative", zIndex: 999 } : {}),
        };

        return (
            <RowDragContext.Provider value={{ listeners, attributes }}>
                <tr
                    ref={setNodeRef}
                    className={className}
                    style={rowStyle}
                    {...restProps}
                    onClick={(e) => {
                        if (isChild) return;
                        if (e.ctrlKey || e.metaKey) {
                            selectedItems.includes(index)
                                ? selectedItems.splice(selectedItems.indexOf(index), 1)
                                : selectedItems.push(index);
                            setSelectedItems(selectedItems);
                        } else {
                            setSelectedItems([]);
                        }
                    }}
                />
            </RowDragContext.Provider>
        );
    };

    /**
     * Tipo de campo:
     * Checkbox: multipleSelection || uniqueSelection
     */
    function handleEditChange(e) {
        if (e === "multipleSelection" || e === "uniqueSelection") {
            setischeckbox(true);
        } else {
            setischeckbox(false);
        }
        setEditingField((pre) => {
            return { ...pre, fieldtype: e };
        });
    }

    /**
     * Classifica e organiza objetos
     * @param {*} values
     * @returns
     */
    function trySortObjects(values) {
        return _(values)
            .map((value, key) => {
                switch (value.fieldtype) {
                    case "refLookup":
                        return {
                            ...value,
                            index: Number(value.index),
                            field: value.field,
                            fieldtype: value.fieldtype,
                            checkBox: value.checkBox
                                ? value.checkBox.reduce((obj, item) => {
                                    if (item && item.currentValue !== undefined) {
                                        Object.assign(obj, {
                                            [Object.keys(obj).length]: item.currentValue,
                                        });
                                    }
                                    return obj;
                                }, {})
                                : null,
                            getValueOf: value.getValueOf,
                            checkValueIn: value.checkValueIn,
                            dica: value.dica,
                            sufixo: value.sufixo,
                            autoFill: value.autoFill,
                            marker: value.marker,
                            returntype: value.returntype
                        };
                    default:
                        return {
                            ...value,
                            index: Number(value.index),
                            field: value.field,
                            fieldtype: value.fieldtype,
                            checkBox: value.checkBox
                                ? value.checkBox.reduce((obj, item) => {
                                    if (item && item.currentValue !== undefined) {
                                        Object.assign(obj, {
                                            [Object.keys(obj).length]: item.currentValue,
                                        });
                                    }
                                    return obj;
                                }, {})
                                : null,
                            refFields: value.refOpt,
                            dica: value.dica,
                            sufixo: value.sufixo,
                            autoFill: value.autoFill,
                            marker: value.marker,
                            returntype: value.returntype
                        };
                }
            })
            .value();
    }

    const wrapValidation = (value) => {
        if (!value) return value;
        if (value.startsWith('VALIDATION(')) return value;
        return `VALIDATION(${value})`;
    }

    const unWrapValidation = (value) => {
        if (!value) return value;

        const match = value.match(/^VALIDATION\((.*)\)$/);
        return match ? match[1] : value;
    }



    const sendValidationForm = async (values) => {
        //
        setLoading(true);
        const functionValidation = values.functionValidation;
        functionValidation.formula = wrapValidation(functionValidation.formula);
        const oldValidation = editingField?.functionValidation || null;
        if (oldValidation && _.isEqual(functionValidation, oldValidation)) {
            Modal.warn({
                title: "Dados semelhantes",
                content: "O valor anterior e o valor atual para função de validação são semelhantes."
            });
            return;
        }

        const fieldId = editingField?._id || null;
        editValidationObj(decodeURIComponent(name), decodeURIComponent(name), fieldId, functionValidation, oldValidation);
        await sleep(1500);
        window.location.reload();
    }

    /**
     * Adiciona campo ao formulário
     * @param {*} values
     */
    const onFinish = async (values) => {
        function sleep(ms) {
            return new Promise((resolve) => setTimeout(resolve, ms));
        }
        if (!isEditing) {
            // Índice 0-based: o primeiro campo novo é anexado logo após os existentes
            // (data.length), mantendo consistência com a normalização feita na ordenação.
            const updatedValues = values.fields.map((campos, idx) => {
                return { ...campos, index: data.length + idx };
            });

            const filteredValues = trySortObjects(updatedValues);

            // Verificação se há conflito entre campo de busca e retorno
            const conflictFieldSearchAndReturn = validateFieldConflictsSearchAndResult(filteredValues);
            if (conflictFieldSearchAndReturn.length > 0) {
                Modal.warning({
                    title: "Conflito entre campo busca e campo retorno",
                    width: 900,
                    content: <ConflictTable
                        conflicts={conflictFieldSearchAndReturn}
                        columnLabels={{
                            secondColumn: "Campo de busca/retorno",
                            thirdColumn: "Formulário de busca",
                            fourthColumn: "Formulário de retorno"
                        }}
                    />
                });
                return;
            }

            // Verifica se há conflito entre o nome do campo, e os valores selecionados
            const conflicts = validateFieldConflicts(filteredValues);
            if (conflicts.length > 0) {
                Modal.warning({
                    title: "Conflito de nomes entre campos",
                    width: 900,
                    content: <ConflictTable conflicts={conflicts} />
                });
                return;
            }

            // Limpa o valor fieldname do array de envio.
            filteredValues.forEach(f => {
                f.getValueOf = stripFieldName(f.getValueOf);
                f.checkValueIn = stripFieldName(f.checkValueIn);
                f.refOpt = stripFieldName(f.refOpt);
                f.refFields = stripFieldName(f.refFields);
            })

            if (values.fields.length > 0) {
                confirm({
                    title: "Confirmar criação desse(s) campo(s)?",
                    icon: <ExclamationCircleOutlined />,
                    content:
                        "Revise seus campos antes da confirmação de sua criação, lembrando que não é possível alterá-los depois de criado!",
                    okText: "Confirmar",
                    cancelText: "Cancelar",
                    onOk: () => {
                        addFields({
                            formName: decodeURIComponent(name),
                            fields: filteredValues,
                            createdBy: user.sub,
                            formId: formDetails[0]?._id,
                            companyId: company.companyId,
                            unitId: company.unitId
                        }).then(async () => {
                            await sleep(1500);
                            window.location.reload();
                        });
                        setaddisVisible(false);
                    }
                });
            }
        } else if (isEditing) {
            values = formEdit.getFieldValue();
            var oldValues = editingField;
            const checkbox = values.checkBox;
            const checkboxvalues = checkbox?.map((item) => {
                return item?.currentValue;
            }).filter(item => item !== undefined);
            const objetoBox = checkboxvalues?.reduce(
                (obj, item) =>
                    Object.assign(obj, {
                        [Object.keys(obj).length]: item,
                    }),
                {}
            );
            // TODO: Encontrar melhor forma de tratar as alteracões do referenciado
            oldValues.refFields = values.refOpt;
            const updatedvalues = {
                ...oldValues,
                refOpt: values.refOpt, // Fix: Garantir que a propriedade refOpt principal seja atualizada com o novo valor
                index: oldValues.index,
                checkBox: objetoBox,
                oldProps: {
                    getValueOf: null,
                    checkValueIn: null,
                },
                //para campos que não possui essa propiedade seja tratada como false
                requiredField: !!oldValues.requiredField,
                autoFillDateTime: !!oldValues.autoFillDateTime
            };
            // Verifica se campo é lookup
            if (updatedvalues.fieldtype === "refLookup") {
                // Verifica se foi alterado os campos de retorno
                if (values.getValueOf && _.size(values.getValueOf) > 0) {
                    updatedvalues.getValueOf = values.getValueOf;
                } else {
                    updatedvalues.getValueOf = oldValues.getValueOf;
                }

                if (values.checkValueIn && _.size(values.checkValueIn) > 0) {
                    updatedvalues.checkValueIn = values.checkValueIn;
                } else {
                    updatedvalues.checkValueIn = oldValues.checkValueIn;
                }

                updatedvalues.oldProps.getValueOf = oldValues.getValueOf;
                updatedvalues.oldProps.checkValueIn = oldValues.checkValueIn;

                if (values.getValueOf || values.checkValueIn) {
                    // Sinaliza que os campos de retorno foram alterados
                    updatedvalues.isChanged = true;
                }

                // TODO: Após encontrar melhor forma de tratar as alteracões do referenciado, remova isso
                delete updatedvalues.refFields;
            }

            // Verifica se há duplicidade entre campo de busca e campo de retorno
            const conflictFieldSearchAndReturn = validateFieldConflictsSearchAndResult([updatedvalues]);
            if (conflictFieldSearchAndReturn.length > 0) {
                Modal.warning({
                    title: "Conflito entre campo busca e campo retorno",
                    width: 900,
                    content: <ConflictTable
                        conflicts={conflictFieldSearchAndReturn}
                        columnLabels={{
                            secondColumn: "Campo de busca/retorno",
                            thirdColumn: "Formulário de busca",
                            fourthColumn: "Formulário de retorno"
                        }}
                    />
                });
                return;
            }

            // Verifica se há conflito entre o nome do campo, e os valores selecionados
            const conflicts = validateFieldConflicts([updatedvalues]);
            if (conflicts.length > 0) {
                Modal.warning({
                    title: "Conflitos de configuração",
                    width: 900,
                    content: <ConflictTable
                        conflicts={conflicts}
                        columnLabels={{
                            thirdColumn: "Tipo do formulário"
                        }} />
                });
                return;
            }

            // Limpa o valor fieldname do array de envio.
            updatedvalues.getValueOf = stripFieldName(updatedvalues.getValueOf);
            updatedvalues.checkValueIn = stripFieldName(updatedvalues.checkValueIn);
            updatedvalues.refOpt = stripFieldName(updatedvalues.refOpt);
            updatedvalues.refFields = stripFieldName(updatedvalues.refFields);


            const responseGetRef = await getReferencedFields({ idField: updatedvalues._id });
            const { forms, quantity } = responseGetRef.data;
            if (quantity > 0) {
                confirm({
                    title: "Campo utilizado em outros formulários",
                    icon: <ExclamationCircleOutlined />,
                    width: 700,
                    content: (
                        <div>
                            <p>Este campo já está sendo utilizado nos seguintes formulários:</p>
                            <ReferenceFieldsRefTable conflicts={forms} />
                            <p style={{ marginTop: 16 }}>
                                Se você continuar, irá alterar os valores de todos os formulários.
                                Deseja continuar mesmo assim?
                            </p>
                        </div>
                    ),
                    okText: "Continuar",
                    cancelText: "Cancelar",
                    onOk: async () => {
                        await editfieldObj(decodeURIComponent(name), updatedvalues, user.sub, {
                            formId: formDetails[0]?._id,
                            companyId: company.companyId,
                            unitId: company.unitId,
                            previous: originalEditingFieldRef.current,
                        });
                        setisEditing(false);
                        form.setFieldsValue({ checkBox: [], refOpt: [] });
                        formEdit.setFieldsValue({ checkBox: [], refOpt: [] });
                        setEditingField(null);
                        await sleep(1200);
                        window.location.reload();
                    }
                });
            }
            else {
                editfieldObj(decodeURIComponent(name), updatedvalues, user.sub, {
                    formId: formDetails[0]?._id,
                    companyId: company.companyId,
                    unitId: company.unitId,
                    previous: originalEditingFieldRef.current,
                }).then(async () => {
                    // Finaliza edição
                    setisEditing(false);
                    form.setFieldsValue({ checkBox: [], refOpt: [] }); // Limpa os campos
                    formEdit.setFieldsValue({ checkBox: [], refOpt: [] });
                    setEditingField(null);
                    // Atualiza
                    await sleep(600);
                    window.location.reload();
                });
            }
        }
    };

    const normalize = value => typeof value === 'string' ? value.trim().toUpperCase() : null;


    function validateFieldConflictsSearchAndResult(fields) {
        const conflicts = [];

        fields.forEach(f => {
            const getValueOf = f.getValueOf || [];
            const checkValueIn = f.checkValueIn || [];
            const returnSet = new Set(
                getValueOf.map(r => `${r.form}::${r.fieldName}`)
            );
            checkValueIn.forEach(r => {
                const key = `${r.form}::${r.fieldName}`;
                if (returnSet.has(key)) {
                    conflicts.push({
                        type: "searchAndReturnConflict",
                        field: f.field,
                        formSearch: r.form.replace("obj_", ""),
                        formReturn: r.form.replace("obj_", ""),
                        fieldName: r.fieldName || null,
                        occurrences: [
                            {
                                type: "Pesquisa",
                                form: r.form.replace("obj_", ""),
                                field: r.field
                            },
                            {
                                type: "Retorno",
                                form: r.form.replace("obj_", ""),
                                field: r.field
                            }
                        ]
                    });
                }
            });
        });

        return conflicts;
    }

    function validateFieldConflicts(fields) {
        const conflicts = [];
        const counter = {};
        fields.forEach(f => {
            const refs = [
                ...(f.checkValueIn || []),
                ...(f.refOpt || []),
            ];

            refs.forEach(r => {
                if (!r.fieldName) return;

                const name = r.fieldName;

                if (!counter[name]) {
                    counter[name] = [];
                }

                counter[name].push({
                    field: f.field,
                    form: r.form.replace("obj_", ""),
                    type:
                        f.checkValueIn?.includes(r) ? "Retorno" :
                            f.refOpt?.includes(r) ? "Referênciado" :
                                "Referênciado"
                });
            });
        });

        Object.keys(counter).forEach(name => {
            if (counter[name].length > 1) {
                conflicts.push({
                    type: "duplicateFieldReference",
                    fieldName: name,
                    occurrences: counter[name]
                })
            }
        })

        fields.forEach(f => {
            const currentName = normalize(f.field);
            const refs = [
                ...(f.checkValueIn || []),
                ...(f.refOpt || [])
            ];

            refs.forEach(r => {
                const refName = normalize(r.fieldName);
                if (currentName && refName && currentName === refName) {
                    conflicts.push({
                        field: f.field,
                        type: f.getValueOf?.includes(r)
                            ? "Pesquisa"
                            : f.checkValueIn?.includes(r)
                                ? "Retorno"
                                : f.refOpt?.includes(r)
                                    ? "Referência"
                                    : "Referência",
                        target: r.fieldName,
                        form: r.form.replace("obj_", "")
                    });
                }
            });
        });

        return conflicts;
    }

    function stripFieldName(arr) {
        if (!Array.isArray(arr)) return arr;
        return arr.map(({ fieldName, ...rest }) => rest);
    }

    const formItemLayout = {
        labelCol: {
            xs: {
                span: 24,
            },
            sm: {
                span: 5,
            },
        },
        wrapperCol: {
            xs: {
                span: 24,
            },
            sm: {
                span: 16,
            },
        },
    };

    const tailFormItemLayout = {
        wrapperCol: {
            xs: {
                span: 1,
                offset: 0,
            },
            sm: {
                span: 12,
                offset: 7,
            },
        },
    };

    /**
     * Lança modal de edição de categoria/confirmação
     */
    const launchEditForm = () => {
        setisEditingForm(true);
    };

    /**
     * Scroll até áncora de todos os campos
     */
    const elementRef = useRef(null);
    const scrollToBottom = () => {
        elementRef.current.scrollIntoView({ behavior: "smooth" });
    };

    /**
     * Âncora para todos os campos
     */
    const AlwaysScrollToBottom = () => {
        return <div ref={elementRef} />;
    };
    /**
     * Detalhes básicos do formulário
     * @param {*} column
     * @returns
     */
    const renderContent = (column = { xs: 1, sm: 1, md: 2, lg: 2, xl: 2, xxl: 2 }) => {
        return (
            <Descriptions size="small" column={column}>
                <Descriptions.Item label="Nome do formulário">
                    {decodeURIComponent(name).replace("obj_", "")}
                </Descriptions.Item>
                <Descriptions.Item
                    label={category.length > 0 ? "Categorias" : "Categoria"}
                >
                    {
                        hasPermissionToEditForm ? (<a href={() => false} onClick={launchEditForm}>
                            {category.length > 0
                                ? `${Object.values(category.map((a) => a.name)).join(", ")}`
                                : "N/A"}
                        </a>) : (Object.values(category.map((a) => a.name)).join(", "))
                    }
                </Descriptions.Item>
                <Descriptions.Item label="Descrição">
                    {
                        hasPermissionToEditForm ? (
                            <a href={() => false} onClick={launchEditForm}>
                                {formDetails[0]?.description ?? "N/A"}
                            </a>
                        ) : formDetails[0]?.description ?? "N/A"
                    }
                </Descriptions.Item>
                <Descriptions.Item label="Quantidade disponível de edição de campos">
                    {
                        <a>
                            {quantityFieldNestedValue} {quantityFieldNestedValue == 1 ? "Edição disponível" : "Edições disponíveis"}.
                        </a>
                    }
                </Descriptions.Item>
            </Descriptions>
        );
    };

    /**
     * Detalhes extras do formulário
     */
    const extraContent = (
        <div
            style={{
                display: "flex",
                width: "max-content",
                justifyContent: "flex-end",
            }}
        >
            <Statistic
                title={dataSource?.length > 0 ? "Campos" : "Campo"}
                value={`${dataSource?.length}`}
                style={{
                    marginRight: 32,
                }}
            />
            <Statistic title="Status" value="Ativo" />
        </div>
    );

    /**
     * Detalhes gerais do formulário
     * @param {*} param
     * @returns
     */
    const Content = ({ children, extra }) => (
        <div className="content">
            <div className="main">{children}</div>
            <div className="extra">{extra}</div>
        </div>
    );

    /**
     * Categoria do formulário
     */
    const categoryRender = (props) => {
        const { label, value, closable, onClose } = props;
        const onPreventMouseDown = (event) => {
            event.preventDefault();
            event.stopPropagation();
        };
        const item = categories.find((x) => x._id === value);
        return (
            <Tag
                color={
                    item && item.color !== undefined
                        ? item.color.hex
                        : "#03A9F4"
                }
                onMouseDown={onPreventMouseDown}
                closable={closable}
                onClose={onClose}
                style={{
                    marginRight: 3,
                }}
            >
                {label !== undefined ? label : "#03A9F4"}
            </Tag>
        );
    };

    const [loading, setLoading] = useState({
        allFields: true,
    });

    // Lista dos campos do formulário
    const fieldNames = dataSource.map(item => item.field.trim().toUpperCase());

    useEffect(() => {
        if (company && permissions) {
            const formName = decodeURIComponent(name).replace("obj_", "");
            const permissionFromFormData = getAllPermissionsByUnit(permissions, company.unitId, [
                'EDIT_FORM',
                'DELETE_FORM',
                'CREATE_FIELD_IN_FORM',
                'EDIT_FIELD_IN_FORM',
                'DELETE_FIELD_IN_FORM',
                'ORDER_FIELDS_IN_FORM',
                'IMPORT_DATA_IN_FORM',
                'VIEW_DATA_ARCHIVED_FROM_FORM'
            ]).filter(item => item.context && item.context.entity_type === "form" && item.context.entity_name === formName)

            if (permissionFromFormData.length === 0) {
                navigate("/403")
            }
            setPermissionsFromForm(permissionFromFormData);
            if (checkPermission(permissionFromFormData, 'IMPORT_DATA_IN_FORM', company.unitId, 'form', null, formName)) {
                importApi.filesHistoryByForm(decodeURIComponent(name), company.unitId).then((items) => {
                    setFilesHistory(Array.isArray(items?.message) ? items.message : []);
                });
            }
        }

    }, [permissions, company, name, navigate]);

    useEffect(() => {
        if (company) {
            let mounted = true;
            let loadingStates = loading;
            if (selectedForm.length && data.length > 0) {
                return;
            }
            /**
             * Campos do formulário
             */
            getMetadataOfObj({ formName: name }).then((items) => {
                if (selectedForm.length && data.length > 0) {
                    return;
                }
                if (mounted) {
                    loadingStates.allFields = false;
                    if (items?.message && items.message.length > 0) {
                        // Procura por campos excluídos
                        const currentFields = items.message.map((x) => {
                            if (x.isDeleted) {
                                return {
                                    ...x,
                                    field: `${x.field} (Arquivado)`,
                                };
                            } else {
                                return {
                                    ...x,
                                };
                            }
                        });
                        // Atualiza tabela
                        const ordered = enforceParentChildOrder(currentFields || []);
                        setData(ordered);
                        setDataSource(ordered);
                    }
                    setLoading(false);
                }
            });
            const formName = decodeURIComponent(name).replace("obj_", "");
            if (formName) {
                importApi.filesHistoryByForm(decodeURIComponent(name), company.unitId).then((result) => {
                    if (result && Array.isArray(result.message)) {
                        setFilesHistory(result.message);
                    } else if (Array.isArray(result)) {
                        setFilesHistory(result);
                    } else {
                        setFilesHistory([]);
                    }
                });
            }
            allCategoriesObj({
                companyId: company.companyId,
                unitId: company.unitId
            }).then((items) => {
                setCategories(items?.message);
                tryGetCategories();
                tryGetNeedConfirmation(decodeURIComponent(name).replace("obj_", ""));
            });
            getQuantityFieldsNested({ formName: name }).then((items) => {
                setQuantityFieldNestedValue(quantityMaxFieldsNested - items.message.value);
                setQuantityFieldNestedBin(quantityMaxFieldsNested - items.message.bin);
            });

            return () => (mounted = false);
        }
    }, [company, selectedForm]);

    /**
     * Modal de edição do campo
     */
    function editField(record) {

        if (record?.fieldtype === 'refMultipleSelection' ||
            record?.fieldtype === 'refUniqueSelection'
        ) {
            setCanSaveGet(false);
        }

        if (record?.fieldtype === 'refLookup') {
            setCanSaveGet(false);
            setCanSaveCheck(false);
        }


        if (
            record?.fieldtype === "multipleSelection" ||
            record?.fieldtype === "uniqueSelection"
        ) {
            setischeckbox(true);
        } else {
            setischeckbox(false);
        }

        originalEditingFieldRef.current = { ...record };
        setEditingField({ ...record });
        setFormEditHasError(false)
        setisEditing(true);
        setWasUpdated(!wasUpdated);

        formEdit.setFieldsValue({
            ...record,
            checkBox: _.values(record.checkBox).map((value) => ({
                currentValue: value,
            })),
            refOpt: record.refFields,
        });
    }

    /**
     * Atualizar campo do formulário
     */
    function sendEditField() {
        form.submit();
    }

    /**
     * Remove campo do formulário
     */
    async function removeField(info) {

        confirm({
            title: "Você realmente deseja excluir esse campo?",
            icon: <ExclamationCircleOutlined />,
            content: "Ao realizar a exclusão, você não poderá mais acessar nenhuma informação referente ao mesmo e também poderá impactar diretamente as FÓRMULAS e AUTOMAÇÕES.",
            okText: "Confirmar",
            async onOk() {
                await dropObjField(decodeURIComponent(name), info._id, user.sub, {
                    field: info.field,
                    fieldtype: info.fieldtype,
                    formId: formDetails[0]?._id,
                    companyId: company.companyId,
                    unitId: company.unitId,
                });
                await sleep(1000);
                window.location.reload();
            },
            cancelText: "Cancelar",
        });
    }

    /**
     * Remove campos arquivados
     */
    function removeArchivedField(info) {
        dropArchivedObjField({
            formName: name,
            fields: dataSource,
            recordId: info._id,
            deletedBy: user.sub
        }).then(async () => {
            await sleep(2000);
            window.location.reload();
        });
    }

    /**
     * Remover formulário
     */
    async function removeForm() {
        const functionDelete = () => {
            confirm({
                title: "Você realmente deseja excluir este item?",
                icon: <ExclamationCircleOutlined />,
                content: "Essa ação não pode ser desfeita, e poderá impactar diretamente as FÓRMULAS e AUTOMAÇÕES.",
                okText: "Confirmar",
                onOk() {
                    dropObj(decodeURIComponent(name), user.sub, {
                        formId: formDetails[0]?._id,
                        companyId: company.companyId,
                        unitId: company.unitId,
                        fields: dataSource,
                    }).then(() => {
                        // remove categorias
                        pullCategoryInObj({
                            formName: decodeURIComponent(name),
                            categories: category.map((cat) => cat._id),
                        }).then(async () => {
                            function sleep(ms) {
                                return new Promise((resolve) => setTimeout(resolve, ms));
                            }

                            await sleep(2000);
                            navigate("/formularios/todos");
                        });
                    });
                },
                cancelText: "Cancelar",
            });
        }
        functionDelete();
    }

    function tryGetCategories() {
        allCategoriesOfObj({
            formName: decodeURIComponent(name),
        }).then((values) => setCategory(values.message));
    }

    function tryGetNeedConfirmation(form) {
        findObject({ name: form }).then((response) => {
            const details = response.message?.[0];

            setFormDetails(response.message || []);

            if (details) {
                setSyncConfig(details.configSync ?? {
                    value: 10,
                    valueType: 'days',
                    fullSync: false,
                });

                setFieldDateMain(details.fieldDateMain ?? null);
            }
        });
    }


    return (
        (<Fragment>
            <LayoutTopSide>
                <TopBar />
                <Layout style={{ overflow: "hidden" }}>
                    <DrawerSider />
                    <Layout
                        style={{
                            padding: "0 24px 24px",
                            height: "100%",
                            overflowY: "auto",
                        }}
                    >
                        <PageHeader
                            style={{ margin: "10px 0 15px 0", background: "var(--cp-surface)" }}
                            onBack={() => window.history.back()}
                            title="Detalhes do formulário"
                            extra={[
                                <Dropdown.Button
                                    menu={{
                                        onClick: (e) => {
                                                switch (e.key) {
                                                    case "1":
                                                        setisEditingForm(true);
                                                        break;
                                                    case "2":
                                                        removeForm();
                                                        break;
                                                    case "3":
                                                        navigate(
                                                            `/formularios/lixeira/${decodeURIComponent(name)}`
                                                        );
                                                        break;
                                                    case "4":
                                                        setIsImportsForm(true);
                                                        break;
                                                    case "5":
                                                        setIsEditingSyncConfig(true)
                                                        break;
                                                    case "6":
                                                        setIsEditingFieldDateMain(true)
                                                        break;
                                                    default:
                                                        break;
                                                }
                                        },
                                        items: [
                                                ...(hasPermissionToEditForm ? [{
                                                    key: 1,
                                                    label: "Editar",
                                                }, {
                                                    key: 5,
                                                    label: "Sincronização",
                                                }, {
                                                    key: 6,
                                                    label: "Data principal",
                                                }] : []),
                                                ...(hasPermissionToViewDataArchivedInForm ? [{
                                                    key: 3,
                                                    label: "Lixeira",
                                                }] : []),
                                                ...(hasPermissionToImportDataInForm ? [{
                                                    key: 4,
                                                    label: "Importações",
                                                }] : []),
                                                ...(hasPermissionToDeleteForm ? [
                                                    {
                                                        key: 2,
                                                        label: "Remover",
                                                        style: {
                                                            color: "white",
                                                            backgroundColor: "red",
                                                            fontWeight: "bolder",
                                                        },
                                                    }
                                                ] : []),
                                        ],
                                    }}
                                >
                                    Opções
                                </Dropdown.Button>,
                            ]}
                        >
                            <Content extra={extraContent}>{renderContent()}</Content>
                        </PageHeader>
                        <Skeleton loading={loading.allFields || permissionsFromForm === null} active avatar>
                            <Row gutter={[1, 16]}>
                                <Col span={24} style={{ background: "var(--cp-surface)" }}>
                                    {/* https://github.com/ant-design/ant-design/blob/6dae4a7e18ad1ba193aedd5ab6867e1d823e2aa4/components/locale/default.tsx#L19-L37 */}
                                    <DndContext
                                        modifiers={[restrictToVerticalAxis]}
                                        onDragEnd={handleDragEnd}
                                    >
                                        <SortableContext
                                            items={dataSource.map((i) => i.index)}
                                            strategy={verticalListSortingStrategy}
                                        >
                                            <Table
                                                style={{ padding: "24px" }}
                                                pagination={false}
                                                dataSource={dataSource.sort((a, b) => a.index - b.index)}
                                                columns={getColumns()}
                                                locale={{
                                                    emptyText: (
                                                        <Empty description="Nenhum campo adicionado." />
                                                    ),
                                                }}
                                                rowKey="index"
                                                components={hasPermissionToOrderFieldsInForm ? {
                                                    body: {
                                                        row: DraggableBodyRow,
                                                    },
                                                } : {}}
                                                bordered
                                            />
                                        </SortableContext>
                                    </DndContext>
                                    {selectedItems.length ? (
                                        <>{selectedItems.length} items selecionados </>
                                    ) : (
                                        ""
                                    )}
                                </Col>
                                <Col span={24} style={{ background: "var(--cp-surface)" }}>
                                    <Form.Provider
                                        onFormFinish={(name, { values, forms }) => {
                                            if (name === "addCheckBoxValue") {
                                                const { basicCheckbox } = forms;
                                                const allCheckboxes =
                                                    basicCheckbox.getFieldValue("allCheckboxes") || [];
                                                basicCheckbox.setFieldsValue({
                                                    allCheckboxes: [...allCheckboxes, values],
                                                });
                                                setVisible(false);
                                            }
                                        }}
                                    >
                                        <Form
                                            {...formItemLayout}
                                            form={form}
                                            name="basicCheckbox"
                                            onFinish={onFinish}
                                            scrollToFirstError
                                            type="flex"
                                            justify="center"
                                        >
                                            <Form.List name="fields">
                                                {(fields, { add, remove }) => (
                                                    <>
                                                        {fields.map(
                                                            ({ key, name, fieldKey, ...restField }) => (
                                                                <React.Fragment key={key}>
                                                                    <Form.Item
                                                                        style={{ marginTop: "3rem" }}
                                                                        {...restField}
                                                                        name={[name, "field"]}
                                                                        label="Nome do campo"
                                                                        fieldKey={[fieldKey, "field"]}
                                                                        rules={[
                                                                            {
                                                                                required: true,
                                                                                message:
                                                                                    "Por favor insira um nome para este campo!",
                                                                            },
                                                                            {
                                                                                pattern: /[^\s]$/,
                                                                                message: "O nome não deve terminar com um espaço!",
                                                                            },
                                                                            {
                                                                                pattern: /^[^.%]*$/,
                                                                                message:
                                                                                    "Este campo não pode conter o caractere ponto (.) ou porcentagem (%)",
                                                                            },
                                                                            {
                                                                                validator: (rule, value) => {
                                                                                    if (
                                                                                        value &&
                                                                                        value.includes("(Arquivado)")
                                                                                    ) {
                                                                                        return Promise.reject(
                                                                                            "(Arquivado) não é permitido no nome do campo."
                                                                                        );
                                                                                    }
                                                                                    if (
                                                                                        value &&
                                                                                        value.includes("(arquivado)")
                                                                                    ) {
                                                                                        return Promise.reject(
                                                                                            "(arquivado) não é permitido no nome do campo."
                                                                                        );
                                                                                    }
                                                                                    return Promise.resolve();
                                                                                },
                                                                            },
                                                                            {
                                                                                validator: (rule, value) => {
                                                                                    const nameFileds = form.getFieldsValue().fields
                                                                                        .filter(item => item.hasOwnProperty('field'))
                                                                                        .map(item => item.field.toLowerCase());

                                                                                    if (_.some(_.countBy(nameFileds), count => count > 1) && !_.isEmpty(value)) {
                                                                                        return Promise.reject(
                                                                                            "Os nomes destes campos devem ser únicos!"
                                                                                        );
                                                                                    }

                                                                                    if (data.filter(item => item.hasOwnProperty('field') && value && item.field.toLowerCase() === value.toLowerCase()).length > 0) {
                                                                                        return Promise.reject(
                                                                                            "Este campo não pode ter o nome repetido"
                                                                                        );
                                                                                    }
                                                                                    return Promise.resolve();
                                                                                }
                                                                            }
                                                                        ]}
                                                                    >
                                                                        <Input placeholder="Ex: Dia de nascimento" />
                                                                    </Form.Item>
                                                                    <Form.Item
                                                                        {...restField}
                                                                        name={[name, "fieldtype"]}
                                                                        label="Tipo"
                                                                        fieldKey={[fieldKey, "fieldtype"]}
                                                                        rules={[
                                                                            {
                                                                                required: true,
                                                                                message:
                                                                                    "Precisamos saber tipo de campo!",
                                                                            },
                                                                        ]}
                                                                    >
                                                                        <Select
                                                                            placeholder="Selecione tipo de campo"
                                                                            onChange={(value) => {
                                                                                // Sufixo só é suportado em Texto e Numérico
                                                                                if (!["Text", "Numeric"].includes(value)) {
                                                                                    form.setFields([{ name: ["fields", name, "sufixo"], value: undefined }]);
                                                                                }
                                                                            }}>
                                                                            <OptGroup label="Simples">
                                                                                <Option value="Text">Texto</Option>
                                                                                <Option value="Numeric">
                                                                                    Numérico
                                                                                </Option>
                                                                                <Option value="Date">
                                                                                    Seleção de data
                                                                                </Option>
                                                                                <Option value="Time">
                                                                                    Seleção de tempo
                                                                                </Option>
                                                                                <Option value="multipleSelection">
                                                                                    Seleção multipla
                                                                                </Option>
                                                                                <Option value="uniqueSelection">
                                                                                    Seleção única
                                                                                </Option>
                                                                                <Option value="formula">
                                                                                    Fórmula
                                                                                </Option>
                                                                                <Option value="label">
                                                                                    Label
                                                                                </Option>
                                                                            </OptGroup>
                                                                            <OptGroup label="Referenciado">
                                                                                <Option value="refLookup">
                                                                                    Consultas
                                                                                </Option>
                                                                                <Option value="refMultipleSelection">
                                                                                    Seleção multipla
                                                                                </Option>
                                                                                <Option value="refUniqueSelection">
                                                                                    Seleção única
                                                                                </Option>
                                                                            </OptGroup>
                                                                        </Select>
                                                                    </Form.Item>
                                                                    <Form.Item
                                                                        {...restField}
                                                                        name={[name, "dica"]}
                                                                        label="Dica"
                                                                        tooltip="Este campo será usado como dica de preenchimento para o usuário no aplicativo!"
                                                                        fieldKey={[fieldKey, "dica"]}
                                                                    >
                                                                        <Input
                                                                            disabled={["formula", "label"].includes(formValues[name]?.fieldtype)} />
                                                                    </Form.Item>
                                                                    <Form.Item
                                                                        {...restField}
                                                                        name={[name, "sufixo"]}
                                                                        label="Sufixo"
                                                                        tooltip="Unidade de medida para o dado adicionado pelo usuário de campo!"
                                                                        fieldKey={[fieldKey, "sufixo"]}
                                                                    >
                                                                        <Input
                                                                            disabled={!["Text", "Numeric"].includes(formValues[name]?.fieldtype)}
                                                                            placeholder="Ex: Oz, L, Kg..." />
                                                                    </Form.Item>
                                                                    <Form.Item
                                                                        {...restField}
                                                                        name={[name, "returntype"]}
                                                                        label="Tipo de Retorno"
                                                                        fieldKey={[fieldKey, "returntype"]}
                                                                        hidden={
                                                                            formValues
                                                                                ? formValues[name]?.fieldtype
                                                                                    ? handleFormulaHidden(formValues[name].fieldtype)
                                                                                    : true
                                                                                : true
                                                                        }
                                                                        rules={[
                                                                            {
                                                                                required: ["formula"].includes(formValues[name]?.fieldtype),
                                                                                message: "Por favor precisamos saber o tipo de retorno desse campo!",
                                                                            },
                                                                        ]}
                                                                    >
                                                                        <Select
                                                                            placeholder="Selecione tipo de retorno do campo">
                                                                            <Option value="Text">
                                                                                Texto
                                                                            </Option>
                                                                            <Option value="Numeric">
                                                                                Numérico
                                                                            </Option>
                                                                        </Select>
                                                                    </Form.Item>
                                                                    <Form.Item
                                                                        name={[name, "formula"]}
                                                                        label="Fórmula"
                                                                        fieldKey={[fieldKey, "formula"]}
                                                                        rules={[
                                                                            {
                                                                                required: formValues[name]?.fieldtype === "formula",
                                                                                message: "Por favor insira uma formula para este campo!",
                                                                            },
                                                                            {
                                                                                validateTrigger: 'onSubmit',
                                                                                validator: async (_, value) => {
                                                                                    if (formValues[name]?.fieldtype === "formula") {
                                                                                        const data = await validateFormula(value, decodeURIComponent(objFormName));
                                                                                        if (data.error) {
                                                                                            let errors = [data.error];
                                                                                            if (data.data) {
                                                                                                errors = [...errors, data.data.join(", ")];
                                                                                            }
                                                                                            return Promise.reject(errors);
                                                                                        }
                                                                                    }
                                                                                    return Promise.resolve();
                                                                                }
                                                                            }
                                                                        ]}
                                                                        hidden={
                                                                            formValues
                                                                                ? formValues[name]?.fieldtype
                                                                                    ? handleFormulaHidden(formValues[name].fieldtype)
                                                                                    : true
                                                                                : true
                                                                        }
                                                                    >
                                                                        {formValues ? (
                                                                            formValues[name]?.fieldtype ? (
                                                                                <Formula
                                                                                    fields={data.map(item => ({
                                                                                        field: item.field,
                                                                                        fieldtype: getFieldType(item.fieldtype)
                                                                                    }))}
                                                                                    form={form}
                                                                                    formName={decodeURIComponent(objFormName)}
                                                                                    getFieldType={getFieldType}
                                                                                    completeFields={data}
                                                                                />
                                                                            ) : null
                                                                        ) : null}
                                                                    </Form.Item>

                                                                    <Form.Item
                                                                        name={[name, "refOpt"]}
                                                                        label="Formulários e campos"
                                                                        fieldKey={[fieldKey, "refOpt"]}
                                                                        hidden={
                                                                            formValues
                                                                                ? formValues[name]?.fieldtype
                                                                                    ? handleCkHidden(
                                                                                        formValues[name].fieldtype
                                                                                    )
                                                                                    : true
                                                                                : true
                                                                        }
                                                                    >
                                                                        {formValues ? (
                                                                            formValues[name]?.fieldtype ? (
                                                                                <TreeTransfer
                                                                                    needUpdated={wasUpdated}
                                                                                    blockedFields={fieldNames}
                                                                                    form={form}
                                                                                    type={removeRef(
                                                                                        formValues[name].fieldtype
                                                                                    )}
                                                                                    refresh={true}
                                                                                    onReady={() => setCanSaveGet(true)}
                                                                                />
                                                                            ) : null
                                                                        ) : null}
                                                                    </Form.Item>

                                                                    <Form.Item
                                                                        name={[name, "getValueOf"]}
                                                                        label="Pesquise"
                                                                        tooltip="Campo chave que será usado na pesquisa para verificar os dados selecionados."
                                                                        fieldKey={[fieldKey, "getValueOf"]}
                                                                        hidden={
                                                                            formValues
                                                                                ? formValues[name]?.fieldtype
                                                                                    ? handleLkHidden(
                                                                                        formValues[name].fieldtype
                                                                                    )
                                                                                    : true
                                                                                : true
                                                                        }
                                                                    >
                                                                        {formValues ? (
                                                                            formValues[name]?.fieldtype ? (
                                                                                <TreeTransferLookup
                                                                                    needUpdated={wasUpdated}
                                                                                    blockedFields={fieldNames}
                                                                                    form={form}
                                                                                    formName={decodeURIComponent(
                                                                                        objFormName
                                                                                    )}
                                                                                    type={removeLk(
                                                                                        formValues[name].fieldtype
                                                                                    )}
                                                                                    single={true}
                                                                                    lookup={true}
                                                                                    refresh={true}
                                                                                    onReady={() => setCanSaveCheck(true)}
                                                                                />
                                                                            ) : null
                                                                        ) : null}
                                                                    </Form.Item>
                                                                    <Form.Item
                                                                        name={[name, "checkValueIn"]}
                                                                        label="Retorne"
                                                                        tooltip="Valor que será retornado na consulta."
                                                                        fieldKey={[fieldKey, "checkValueIn"]}
                                                                        hidden={
                                                                            formValues
                                                                                ? formValues[name]?.fieldtype
                                                                                    ? handleLkHidden(
                                                                                        formValues[name].fieldtype
                                                                                    )
                                                                                    : true
                                                                                : true
                                                                        }
                                                                    >
                                                                        {formValues ? (
                                                                            formValues[name]?.fieldtype ? (
                                                                                <TreeTransfer
                                                                                    needUpdated={wasUpdated}
                                                                                    blockedFields={fieldNames}
                                                                                    form={form}
                                                                                    formName={decodeURIComponent(
                                                                                        objFormName
                                                                                    )}
                                                                                    type={removeRef(
                                                                                        formValues[name].fieldtype
                                                                                    )}
                                                                                    refresh={true}
                                                                                    removeSelected={true}
                                                                                    onReady={() => setCanSaveGet(true)}
                                                                                />
                                                                            ) : null
                                                                        ) : null}
                                                                    </Form.Item>

                                                                    <Form.Item
                                                                        wrapperCol={{ span: 24, offset: 5 }}
                                                                        hidden={
                                                                            formValues
                                                                                ? formValues[name]?.fieldtype
                                                                                    ? handleRfHidden(
                                                                                        formValues[name].fieldtype
                                                                                    )
                                                                                    : true
                                                                                : true
                                                                        }
                                                                    >
                                                                        <CheckBoxForm fieldKey={name} isHidden={
                                                                            formValues
                                                                                ? formValues[name]?.fieldtype
                                                                                    ? handleRfHidden(
                                                                                        formValues[name].fieldtype
                                                                                    )
                                                                                    : true
                                                                                : true
                                                                        } />
                                                                    </Form.Item>
                                                                    <Form.Item
                                                                        {...restField}
                                                                        name={[name, "marker"]}
                                                                        label="Etiqueta"
                                                                        tooltip="Destaca o campo na lista de lançamentos do aplicativo."
                                                                        fieldKey={[fieldKey, "marker"]}
                                                                        rules={
                                                                            formValues[name]?.fieldtype !== 'label' ? (formValues
                                                                                ? formValues[name]?.fieldtype
                                                                                    ? handleDtRules(
                                                                                        formValues[name].fieldtype
                                                                                    )
                                                                                    : handleDtRules()
                                                                                : handleDtRules()) : []
                                                                        }
                                                                    >
                                                                        <Radio.Group
                                                                            disabled={
                                                                                (formValues
                                                                                    ? formValues[name]?.fieldtype
                                                                                        ? handleDtHidden(
                                                                                            formValues[name].fieldtype
                                                                                        )
                                                                                        : null
                                                                                    : null)
                                                                                || ["label"].includes(formValues[name]?.fieldtype)
                                                                            }
                                                                        >
                                                                            <Radio value={true}>Sim</Radio>
                                                                            <Radio value={false}>Não</Radio>
                                                                        </Radio.Group>
                                                                    </Form.Item>
                                                                    <Form.Item
                                                                        hidden={!['Date', 'Time'].includes(formValues[name]?.fieldtype)}
                                                                        {...restField}
                                                                        name={[name, "autoFillDateTime"]}
                                                                        label="Preenchimento Automático do Campo"
                                                                        tooltip="Campo será preenchido com data ou hora atual!"
                                                                        rules={
                                                                            ['Date', 'Time'].includes(formValues[name]?.fieldtype)
                                                                                ? [
                                                                                    {
                                                                                        required: true,
                                                                                        message: "Por favor, informe se o campo será preenchido automaticamente com data ou hora atual.",
                                                                                    },
                                                                                ]
                                                                                : []
                                                                        }
                                                                    >
                                                                        <Radio.Group>
                                                                            <Radio value={true}>Sim</Radio>
                                                                            <Radio value={false}>Não</Radio>
                                                                        </Radio.Group>
                                                                    </Form.Item>

                                                                    <Form.Item
                                                                        {...restField}
                                                                        name={[name, "autoFill"]}
                                                                        label="Preenchimento"
                                                                        tooltip="Campo será preenchido com último registro enviado!"
                                                                        fieldKey={[fieldKey, "autoFill"]}
                                                                        rules={[
                                                                            {
                                                                                required: !["formula", "label"].includes(formValues[name]?.fieldtype),
                                                                                message: "Precisamos saber se você deseja que este campo preenchido com último registro enviado!",
                                                                            },
                                                                        ]}
                                                                    >
                                                                        <Radio.Group
                                                                            disabled={["formula", "label"].includes(formValues[name]?.fieldtype)}>
                                                                            <Radio value={true}>Sim</Radio>
                                                                            <Radio value={false}>Não</Radio>
                                                                        </Radio.Group>
                                                                    </Form.Item>
                                                                    <Form.Item
                                                                        {...restField}
                                                                        name={[name, "requiredField"]}
                                                                        label="Campo obrigatório"
                                                                        tooltip="Campo obrigatório para preenchimento no formulário enviado!"
                                                                        fieldKey={[fieldKey, "requiredField"]}
                                                                        rules={[
                                                                            {
                                                                                required: !["formula", "label"].includes(formValues[name]?.fieldtype),
                                                                                message: "Precisamos saber se você deseja que este campo sejá obrigatório ou não!",
                                                                            },
                                                                        ]}
                                                                    >
                                                                        <Radio.Group
                                                                            disabled={["formula", "label"].includes(formValues[name]?.fieldtype)}>
                                                                            <Radio value={true}>Sim</Radio>
                                                                            <Radio value={false}>Não</Radio>
                                                                        </Radio.Group>
                                                                    </Form.Item>
                                                                    <Form.Item
                                                                        {...tailFormItemLayout}
                                                                        wrapperCol={{ span: 24, offset: 5 }}
                                                                    >
                                                                        <Button
                                                                            danger
                                                                            onClick={() => {
                                                                                remove(name);
                                                                                if (fields.length <= 1) {
                                                                                    setaddisVisible(false);
                                                                                }
                                                                            }}
                                                                            icon={<MinusCircleOutlined />}
                                                                        >
                                                                            Remover campo
                                                                        </Button>
                                                                    </Form.Item>
                                                                </React.Fragment>
                                                            )
                                                        )}
                                                        {
                                                            company && formDetails.length > 0 && checkPermission(permissionsFromForm, 'CREATE_FIELD_IN_FORM', company.unitId, 'form', formDetails[0]._id) && (
                                                                <List.Item
                                                                    style={{
                                                                        paddingTop: "1rem",
                                                                        paddingBottom: "1rem",
                                                                        marginLeft: "1.5rem",
                                                                        marginRight: "1.5rem",
                                                                    }}
                                                                >
                                                                    <Button
                                                                        disabled={quantityFieldNestedValue == 0}
                                                                        type="dashed"
                                                                        onClick={() => {
                                                                            add();
                                                                            setaddisVisible(true);
                                                                            scrollToBottom();
                                                                        }}
                                                                        block
                                                                        icon={<PlusOutlined />}
                                                                    >
                                                                        Adicionar campo
                                                                    </Button>
                                                                    <AlwaysScrollToBottom />
                                                                </List.Item>
                                                            )
                                                        }

                                                    </>
                                                )}
                                            </Form.List>
                                            <List.Item
                                                style={
                                                    addisVisible === false
                                                        ? { display: "none" }
                                                        : { display: "flex", paddingTop: 0 }
                                                }
                                            >
                                                <Button
                                                    style={{
                                                        marginBottom: ".5rem",
                                                        marginLeft: "1.5rem",
                                                        marginRight: "1.5rem",
                                                    }}
                                                    block
                                                    type="primary"
                                                    htmlType="submit"
                                                >
                                                    Adicionar campos ao formulário
                                                </Button>
                                            </List.Item>

                                            {/* Modal para inclusão/alteração da validação do formulário */}
                                            <Modal
                                                width={900}
                                                title="Validação de dados"
                                                open={isEditingValidationForm}
                                                cancelText="Cancelar"
                                                okText="Salvar"
                                                onCancel={() => {
                                                    setIsEditingValidationForm(false);
                                                }}
                                                onOk={() => {
                                                    formValidation.submit();
                                                }}
                                            >

                                                <Form
                                                    form={formValidation}
                                                    layout="vertical"
                                                    onFinish={sendValidationForm}
                                                >
                                                    <Formula
                                                        form={formValidation}
                                                        code={editingField?.functionValidation?.formula}
                                                        onChange={(value) => {
                                                            setEditingField((pre) => {
                                                                return { ...pre };
                                                            });
                                                        }}
                                                        formName={decodeURIComponent(
                                                            objFormName
                                                        )}
                                                        field={editingField?.field}
                                                        fields={data.map(item => ({
                                                            field: item.field,
                                                            fieldtype: getFieldType(item.fieldtype)
                                                        }))}
                                                        getFieldType={getFieldType}
                                                        completeFields={data}
                                                        isValidationForm={true}
                                                    />
                                                </Form>

                                            </Modal>

                                            {/* Edição do campo */}
                                            <Modal
                                                width={900}
                                                okButtonProps={{
                                                    disabled: formEditHasError
                                                }}
                                                title="Editar campo"
                                                open={isEditing}
                                                cancelText="Cancelar"
                                                onCancel={() => {
                                                    setisEditing(false);
                                                    // limpa os campos
                                                    form.setFieldsValue({ checkBox: [], refOpt: [] }); // Clear the form list
                                                    formEdit.setFieldsValue({ checkBox: [], refOpt: [] });
                                                    setEditingField(null);
                                                }}
                                                okText={(canSaveGet && canSaveCheck) ? "Salvar" : "Carregando..."}
                                                htmlType="submit"
                                                onOk={() => {
                                                    if (canSaveGet && canSaveCheck) {
                                                        formEdit.submit();
                                                    } else {
                                                        Modal.warn({
                                                            title: "Campos carregando",
                                                            content: "Ainda há campos que estão carregando, aguarde ..."
                                                        });
                                                    }
                                                }}
                                            >
                                                <Form
                                                    form={formEdit}
                                                    name="basicCheckbox"
                                                    onFinish={() => {
                                                        sendEditField();
                                                    }}
                                                    onFieldsChange={() => {
                                                        let errors = formEdit.getFieldsError();
                                                        let hasErrors = errors.some(fieldError => !!fieldError.errors.length);
                                                        setFormEditHasError(hasErrors)
                                                    }}
                                                >
                                                    <p>Nome do campo</p>
                                                    <Form.Item
                                                        name={"field"}
                                                        style={{ width: "100%", marginBottom: 0 }}
                                                        wrapperCol={{ span: 24, offset: 0 }}
                                                        rules={[
                                                            {
                                                                required: true,
                                                                message:
                                                                    "Por favor insira um nome para este campo!",
                                                            },
                                                            {
                                                                pattern: /[^\s]$/,
                                                                message: "O nome não deve terminar com um espaço!",
                                                            },
                                                            {
                                                                pattern: /^[^.%]*$/,
                                                                message:
                                                                    "Este campo não pode conter o caractere ponto (.) ou porcentagem (%)",
                                                            },
                                                            {
                                                                validator: (rule, value) => {
                                                                    if (
                                                                        value &&
                                                                        value.includes("(Arquivado)")
                                                                    ) {
                                                                        return Promise.reject(
                                                                            "(Arquivado) não é permitido no nome do campo."
                                                                        );
                                                                    }
                                                                    if (
                                                                        value &&
                                                                        value.includes("(arquivado)")
                                                                    ) {
                                                                        return Promise.reject(
                                                                            "(arquivado) não é permitido no nome do campo."
                                                                        );
                                                                    }
                                                                    return Promise.resolve();
                                                                },
                                                            },
                                                            {
                                                                validator: (rule, value) => {
                                                                    if (!_.isEmpty(value) && _.isEmpty(value.trim())) {
                                                                        return Promise.reject(
                                                                            "Este campo não pode ter o nome vazio ou somente espaços!"
                                                                        );
                                                                    }
                                                                    if (data.filter(item => !item.isReadOnly && item.field.toLowerCase() == value.toLowerCase() && item._id != editingField._id).length > 0) {
                                                                        return Promise.reject(
                                                                            "Este campo não pode ter o nome repetido!"
                                                                        );
                                                                    }
                                                                    return Promise.resolve();
                                                                }
                                                            }
                                                        ]}
                                                    >
                                                        <Input
                                                            style={{ marginBottom: 15 }}
                                                            value={editingField?.field}
                                                            onChange={(e) => {
                                                                setEditingField((prev) => ({
                                                                    ...prev,
                                                                    field: e.target.value,
                                                                }));
                                                            }}
                                                        />
                                                    </Form.Item>
                                                    <p>Dica</p>
                                                    <Input
                                                        style={{ marginBottom: 15 }}
                                                        value={editingField?.dica}
                                                        onChange={(e) => {
                                                            setEditingField((pre) => {
                                                                return { ...pre, dica: e.target.value };
                                                            });
                                                        }}
                                                        disabled={["formula", "label"].includes(editingField?.fieldtype)}
                                                    />
                                                    <p>Sufixo</p>
                                                    <Input
                                                        style={{ marginBottom: 15 }}
                                                        value={editingField?.sufixo}
                                                        onChange={(e) => {
                                                            setEditingField((pre) => {
                                                                return { ...pre, sufixo: e.target.value };
                                                            });
                                                        }}
                                                        disabled={!["Text", "Numeric"].includes(editingField?.fieldtype)}
                                                    />
                                                    <p>Tipo do campo</p>
                                                    <Select
                                                        style={{ width: "100%", marginBottom: 15 }}
                                                        value={editingField?.fieldtype}
                                                        onChange={(e) => {
                                                            handleEditChange(e);
                                                        }}
                                                        placeholder="Selecione tipo do campo"
                                                        disabled={true}
                                                    >
                                                        <Option value="Text">Texto</Option>
                                                        <Option value="Numeric">Numérico</Option>
                                                        <Option value="multipleSelection">
                                                            Seleção Múltipla
                                                        </Option>
                                                        <Option value="refMultipleSelection">
                                                            Seleção Múltipla Referenciada
                                                        </Option>
                                                        <Option value="refUniqueSelection">
                                                            Seleção Única Referenciada
                                                        </Option>
                                                        <Option value="uniqueSelection">Seleção Única</Option>
                                                        <Option value="Date">Seleção de Data</Option>
                                                        <Option value="Time">Seleção de tempo</Option>
                                                        <Option value="refLookup">Consulta</Option>
                                                        <Option value="formula">Fórmula</Option>
                                                    </Select>
                                                    {(["formula"].includes(editingField?.fieldtype)) && (<>
                                                        <p>Tipo de Retorno</p>
                                                        <Select
                                                            style={{ width: "100%", marginBottom: 15 }}
                                                            placeholder="Selecione tipo de retorno do campo"
                                                            disabled={true}
                                                            value={editingField?.returntype}
                                                        >
                                                            <Option value="Text">
                                                                Texto
                                                            </Option>
                                                            <Option value="Numeric">
                                                                Numérico
                                                            </Option>
                                                        </Select>
                                                    </>)}

                                                    {editingField?.fieldtype === "formula" ? <p>Fórmula</p> : null}
                                                    <Form.Item
                                                        name={"formula"}
                                                        style={{ width: "100%" }}
                                                        wrapperCol={{ span: 24, offset: 0 }}
                                                        hidden={editingField?.fieldtype !== "formula"}
                                                        rules={[
                                                            {
                                                                required: editingField?.fieldtype === "formula",
                                                                message: "Por favor insira uma fórmula para este campo!",
                                                            },
                                                            {
                                                                validateTrigger: 'onSubmit',
                                                                validator: async function (_, value) {
                                                                    if (editingField?.fieldtype === "formula") {
                                                                        const data = await validateFormula(value, decodeURIComponent(objFormName));
                                                                        if (data.error) {
                                                                            let errors = [data.error];
                                                                            if (data.data) {
                                                                                errors = [...errors, data.data.join(", ")];
                                                                            }
                                                                            return Promise.reject(errors);
                                                                        }
                                                                    }

                                                                    return Promise.resolve();
                                                                }
                                                            }
                                                        ]
                                                        }
                                                    >
                                                        <Formula
                                                            form={formEdit}
                                                            code={editingField?.formula}
                                                            onChange={(value) => {
                                                                setEditingField((pre) => {
                                                                    return { ...pre, formula: value };
                                                                });
                                                            }}
                                                            formName={decodeURIComponent(
                                                                objFormName
                                                            )}
                                                            field={editingField?.field}
                                                            fields={data.map(item => ({
                                                                field: item.field,
                                                                fieldtype: getFieldType(item.fieldtype)
                                                            }))}
                                                            getFieldType={getFieldType}
                                                            completeFields={data}
                                                        />
                                                    </Form.Item>
                                                    <Form.Item
                                                        style={{ width: "100%", marginBottom: 0 }}
                                                        wrapperCol={{ span: 24, offset: 0 }}
                                                        hidden={!ischeckbox}
                                                    >
                                                        {ischeckbox && (
                                                            <Form.List 
                                                                name="checkBox"
                                                                rules={[
                                                                    {
                                                                        validator: async (_, checkBox) => {
                                                                            if (!ischeckbox) {
                                                                                return Promise.resolve();
                                                                            }
                                                                            if (!checkBox || checkBox.length < 1) {
                                                                                return Promise.reject(new Error("Adicione pelo menos uma opção!"));
                                                                            }
                                                                        },
                                                                    },
                                                                ]}
                                                            >
                                                                {(checkBox, { add, remove }, { errors }) => {
                                                                    return (
                                                                        <div>
                                                                            {checkBox.map((currentValue, index2) => (
                                                                                <Space
                                                                                    key={currentValue.key}
                                                                                    style={{
                                                                                        display: "flex",
                                                                                        marginBottom: 8,
                                                                                    }}
                                                                                    align="start"
                                                                                >
                                                                                    <Form.Item
                                                                                        {...currentValue}
                                                                                        name={[
                                                                                            currentValue.name,
                                                                                            "currentValue",
                                                                                        ]}
                                                                                        fieldKey={[
                                                                                            currentValue.fieldKey,
                                                                                            "currentValue",
                                                                                        ]}
                                                                                        key={index2}
                                                                                        // noStyle
                                                                                        rules={[
                                                                                            {
                                                                                                required: true,
                                                                                                message: "Este campo é obrigatório",
                                                                                            },
                                                                                            {
                                                                                                validator: (_, value) => {
                                                                                                    if (
                                                                                                        value &&
                                                                                                        value.includes(",")
                                                                                                    ) {
                                                                                                        return Promise.reject(
                                                                                                            "O texto não pode conter vírgulas!"
                                                                                                        );
                                                                                                    }
                                                                                                    return Promise.resolve();
                                                                                                },
                                                                                            },
                                                                                            {
                                                                                                validator: (_, value) => {
                                                                                                    if (
                                                                                                        value &&
                                                                                                        value.includes(";")
                                                                                                    ) {
                                                                                                        return Promise.reject(
                                                                                                            "O texto não pode conter pontos e vírgulas!"
                                                                                                        );
                                                                                                    }
                                                                                                    return Promise.resolve();
                                                                                                },
                                                                                            },
                                                                                        ]}
                                                                                    >
                                                                                        <Input />
                                                                                    </Form.Item>
                                                                                    <MinusCircleOutlined
                                                                                        style={{
                                                                                            paddingTop: 8,
                                                                                        }}
                                                                                        onClick={() =>
                                                                                            remove(currentValue.name)
                                                                                        }
                                                                                    />
                                                                                </Space>
                                                                            ))}
                                                                            <Form.Item>
                                                                                <Button type="dashed" onClick={() => add()}>
                                                                                    <PlusOutlined /> Adicionar item
                                                                                </Button>
                                                                                <Form.ErrorList errors={errors} />
                                                                            </Form.Item>
                                                                        </div>
                                                                    );
                                                                }}
                                                            </Form.List>
                                                        )}
                                                    </Form.Item>
                                                    <Form.Item
                                                        name="refOpt"
                                                        style={{ width: "100%" }}
                                                        wrapperCol={{ span: 24, offset: 0 }}
                                                        hidden={!isref}
                                                    >
                                                        {isref && (
                                                            <TreeTransfer
                                                                needUpdated={wasUpdated}
                                                                blockedFields={fieldNames}
                                                                form={form}
                                                                type={`${editingField?.fieldtype
                                                                    .substring(3)
                                                                    .charAt(0)
                                                                    .toLowerCase()}${editingField?.fieldtype
                                                                        .substring(3)
                                                                        .substring(1)}`}
                                                                selected={editingField?.refFields}
                                                                refresh={true}
                                                                onReady={() => setCanSaveGet(true)}
                                                            />
                                                        )}
                                                    </Form.Item>
                                                    <Form.Item
                                                        name={"getValueOf"}
                                                        wrapperCol={{ span: 24, offset: 0 }}
                                                        hidden={
                                                            editingField
                                                                ? editingField?.fieldtype
                                                                    ? handleLkHidden(editingField?.fieldtype)
                                                                    : true
                                                                : true
                                                        }
                                                    >
                                                        {editingField ? (
                                                            editingField?.fieldtype ? (
                                                                <TreeTransferLookup
                                                                    needUpdated={wasUpdated}
                                                                    blockedFields={fieldNames}
                                                                    form={form}
                                                                    formName={decodeURIComponent(objFormName)}
                                                                    type={removeLk(editingField.fieldtype)}
                                                                    selected={editingField?.getValueOf}
                                                                    single={true}
                                                                    lookup={true}
                                                                    refresh={true}
                                                                    onReady={() => setCanSaveCheck(true)}
                                                                />
                                                            ) : null
                                                        ) : null}
                                                    </Form.Item>
                                                    <Form.Item
                                                        name="checkValueIn"
                                                        style={{ width: "100%" }}
                                                        wrapperCol={{ span: 24, offset: 0 }}
                                                        hidden={
                                                            editingField
                                                                ? editingField?.fieldtype
                                                                    ? handleLkHidden(editingField?.fieldtype)
                                                                    : true
                                                                : true
                                                        }
                                                    >
                                                        {editingField ? (
                                                            editingField?.fieldtype ? (
                                                                <TreeTransfer
                                                                    needUpdated={wasUpdated}
                                                                    blockedFields={fieldNames}
                                                                    form={form}
                                                                    formName={decodeURIComponent(objFormName)}
                                                                    type={removeRef(editingField.fieldtype)}
                                                                    selected={editingField?.checkValueIn}
                                                                    refresh={true}
                                                                    removeSelected={true}
                                                                    onReady={() => setCanSaveGet(true)}
                                                                />
                                                            ) : null
                                                        ) : null}
                                                    </Form.Item>
                                                    <p>Etiqueta</p>
                                                    <Form.Item
                                                        name={"marker"}
                                                        style={{ width: "100%", marginBottom: 0 }}
                                                        wrapperCol={{ span: 24, offset: 0 }}
                                                    >
                                                        <Radio.Group
                                                            style={{ width: "100%", marginBottom: 15 }}
                                                            onChange={(e) => {
                                                                setEditingField((pre) => {
                                                                    return { ...pre, marker: e.target.value };
                                                                });
                                                            }}
                                                            disabled={["label"].includes(editingField?.fieldtype)}
                                                        >
                                                            <Radio value={true}>Sim</Radio>
                                                            <Radio value={false}>Não</Radio>
                                                        </Radio.Group>
                                                    </Form.Item>
                                                    {!(editingField && !['Date', 'Time'].includes(editingField?.fieldtype)) ? <p>Preenchimento Automático do Campo</p> : null}
                                                    <Form.Item
                                                        hidden={editingField && !['Date', 'Time'].includes(editingField?.fieldtype)}
                                                        name={[name, "autoFillDateTime"]}
                                                        tooltip="Campo será preenchido com data ou hora atual!"
                                                    >
                                                        <Radio.Group
                                                            defaultValue={!!editingField?.autoFillDateTime}
                                                            onChange={(e) => {
                                                                setEditingField((pre) => {
                                                                    return { ...pre, autoFillDateTime: e.target.value };
                                                                });

                                                            }}>
                                                            <Radio value={true}>Sim</Radio>
                                                            <Radio value={false}>Não</Radio>
                                                        </Radio.Group>
                                                    </Form.Item>

                                                    <p>Preenchimento</p>
                                                    <Form.Item
                                                        name={"autoFill"}
                                                        style={{ width: "100%", marginBottom: 0 }}
                                                        wrapperCol={{ span: 24, offset: 0 }}
                                                    >
                                                        <Radio.Group
                                                            style={{ width: "100%", marginBottom: 15 }}
                                                            onChange={(e) => {
                                                                setEditingField((pre) => {
                                                                    return { ...pre, autoFill: e.target.value };
                                                                });
                                                            }}
                                                            disabled={["label", "formula"].includes(editingField?.fieldtype)}
                                                        >
                                                            <Radio value={true}>Sim</Radio>
                                                            <Radio value={false}>Não</Radio>
                                                        </Radio.Group>
                                                    </Form.Item>
                                                    <p>Campo obrigatório</p>
                                                    <Form.Item
                                                        name={"requiredField"}
                                                        style={{ width: "100%", marginBottom: 0 }}
                                                        wrapperCol={{ span: 24, offset: 0 }}
                                                    >
                                                        <Radio.Group
                                                            style={{ width: "100%", marginBottom: 15 }}
                                                            onChange={(e) => {
                                                                setEditingField((pre) => {
                                                                    return { ...pre, requiredField: e.target.value };
                                                                });
                                                            }}
                                                            disabled={["label", "formula"].includes(editingField?.fieldtype)}
                                                        >
                                                            <Radio value={true}>Sim</Radio>
                                                            <Radio value={false}>Não</Radio>
                                                        </Radio.Group>
                                                    </Form.Item>
                                                </Form>
                                            </Modal>
                                        </Form>
                                        {/* Edição do formulário */}
                                        <Modal
                                            title="Editar formulário"
                                            open={isEditingForm}
                                            cancelText="Cancelar"
                                            onCancel={(e) => {
                                                tryGetCategories();
                                                setisEditingForm(false);
                                            }}
                                            footer={null}
                                        >
                                            <p>Categoria</p>
                                            <Select
                                                mode="multiple"
                                                defaultValue={category?.map(a => ({
                                                    value: a._id.toString(),
                                                    label: a.name
                                                }))}
                                                onSelect={(id) => {
                                                    const selected = categories.find((c) => c._id === id);
                                                    pushCategoryInObj({
                                                        formName: decodeURIComponent(name),
                                                        categories: [id],
                                                        updatedBy: user.sub,
                                                        formId: formDetails[0]?._id,
                                                        companyId: company.companyId,
                                                        unitId: company.unitId,
                                                        categoriesData: [{ categoryId: id, categoryName: selected?.name }]
                                                    });
                                                }}
                                                onDeselect={(id) => {
                                                    const selected = categories.find((c) => c._id === id);
                                                    pullCategoryInObj({
                                                        formName: decodeURIComponent(name),
                                                        categories: [id],
                                                        updatedBy: user.sub,
                                                        formId: formDetails[0]?._id,
                                                        companyId: company.companyId,
                                                        unitId: company.unitId,
                                                        categoriesData: [{ categoryId: id, categoryName: selected?.name }]
                                                    });
                                                }}
                                                style={{ width: "100%", marginBottom: 15 }}
                                                tagRender={categoryRender}
                                                placeholder="Selecione categoria do formulário"
                                                optionFilterProp="children"
                                                filterOption={(input, option) =>
                                                    (option?.children ?? '').toLowerCase().includes(input.toLowerCase())
                                                }
                                            >
                                                {categories.map((category) => (
                                                    <Option key={category._id} value={category._id}>{category.name}</Option>
                                                ))}
                                            </Select>
                                            <p>Descrição</p>
                                            <Input.TextArea
                                                rows={4}
                                                defaultValue={formDetails[0]?.description || ""}
                                                onBlur={(e) => {
                                                    const value = e.target.value;
                                                    changeDescriptionInObj({
                                                        id: formDetails[0]._id,
                                                        description: value,
                                                        updatedBy: user.sub,
                                                        formName: decodeURIComponent(name),
                                                        companyId: company.companyId,
                                                        unitId: company.unitId
                                                    }).then(() => {
                                                        // atualiza
                                                        tryGetCategories();
                                                        setFormDetails([
                                                            {
                                                                ...formDetails[0],
                                                                description: value,
                                                            },
                                                        ]);
                                                        // setisEditingForm(false);
                                                    });
                                                }}
                                            />
                                        </Modal>
                                    </Form.Provider>
                                </Col>
                            </Row>
                            {/*Modal de Configuração de sincronização*/}
                            <Modal
                                title="Configuração de sincronização de dados offline"
                                open={isEditingSyncConfig}
                                cancelText="Cancelar"
                                okText="Salvar"
                                onCancel={() => setIsEditingSyncConfig(false)}
                                onOk={async () => {
                                    await changeConfigSyncInObj({
                                        id: formDetails[0]._id,
                                        configSync: syncConfig,
                                        updatedBy: user.sub,
                                        formName: decodeURIComponent(name),
                                        companyId: company.companyId,
                                        unitId: company.unitId
                                    });
                                    await sleep(1000);
                                    await tryGetNeedConfirmation(decodeURIComponent(name).replace("obj_", ""));
                                    setIsEditingSyncConfig(false);
                                }}
                            >
                                <Form layout="vertical">
                                    <Form.Item label="Sincronizar dados dos últimos">
                                        <Space.Compact>
                                            <InputNumber
                                                min={1}
                                                disabled={syncConfig.fullSync}
                                                value={syncConfig.value}
                                                onChange={(val) =>
                                                    setSyncConfig((prev) => ({ ...prev, value: val }))
                                                }
                                            />
                                            <Select
                                                value={syncConfig.valueType}
                                                disabled={syncConfig.fullSync}
                                                style={{ width: 120 }}
                                                onChange={(val) =>
                                                    setSyncConfig((prev) => ({ ...prev, valueType: val }))
                                                }
                                            >
                                                <Select.Option value="minutes">Minutos</Select.Option>
                                                <Select.Option value="hours">Horas</Select.Option>
                                                <Select.Option value="days">Dias</Select.Option>
                                                <Select.Option value="months">Meses</Select.Option>
                                                <Select.Option value="years">Anos</Select.Option>
                                            </Select>
                                        </Space.Compact>
                                    </Form.Item>

                                    <Form.Item>
                                        <Checkbox
                                            checked={syncConfig.fullSync}
                                            onChange={(e) => {
                                                const checked = e.target.checked;
                                                setSyncConfig((prev) => ({
                                                    ...prev,
                                                    fullSync: checked,
                                                }));
                                            }}
                                        >
                                            Sincronizar desde o começo
                                        </Checkbox>
                                    </Form.Item>
                                </Form>
                            </Modal>
                            {/*Modal de Seleção da Data Principal*/}
                            <Modal
                                title="Selecionar Data principal do formulário"
                                open={isEditingFieldDateMain}
                                cancelText="Cancelar"
                                okText="Salvar"
                                onCancel={() => setIsEditingFieldDateMain(false)}
                                onOk={async () => {
                                    await changeFieldDateMainInObj({
                                        id: formDetails[0]._id,
                                        field: fieldDateMain,
                                        updatedBy: user.sub,
                                        formName: decodeURIComponent(name),
                                        companyId: company.companyId,
                                        unitId: company.unitId
                                    });
                                    await sleep(1000);
                                    await tryGetNeedConfirmation(decodeURIComponent(name).replace("obj_", ""));
                                    setIsEditingFieldDateMain(false);
                                }}
                            >
                                <Select
                                    allowClear={true}
                                    value={fieldDateMain}
                                    style={{ width: "100%" }}
                                    onChange={(val) => setFieldDateMain(val)}
                                >
                                    <Select.Option value={""}>
                                        Selecione uma opção
                                    </Select.Option>
                                    {
                                        dataSource
                                            .filter(item => item.fieldtype === "Date")
                                            .map(item => {
                                                return (
                                                    <Select.Option value={item._id}>{
                                                        item.field
                                                    }</Select.Option>
                                                )
                                            })
                                    }
                                </Select>
                            </Modal>
                            {/* Importações */}
                            <Modal
                                title="Importações"
                                open={isImportsForm}
                                cancelText="Cancelar"
                                onCancel={(e) => {
                                    setIsImportsForm(false);
                                }}
                                footer={null}
                            >
                                <Row>
                                    <Col span={24}>
                                        {filesHistory.length > 0 ? (
                                            <List
                                                style={{ marginTop: "-.5rem" }}
                                                itemLayout="horizontal"
                                                dataSource={filesHistory.map((item, index) => ({
                                                    // Swap item and index parameters
                                                    key: index,
                                                    _id: item._id,
                                                    title: `Arquivo CSV ${index > 0 ? `(${index + 1})` : ""
                                                        }`,
                                                    description: moment(item.createdAt).format("LLL"),
                                                }))}
                                                renderItem={(
                                                    item // Remove index parameter
                                                ) => (
                                                    <List.Item
                                                        actions={[
                                                            <Button
                                                                type="primary"
                                                                onClick={() => {
                                                                    navigate(
                                                                        `/formularios/importar/detalhes/${item._id}?form=${objFormName}`
                                                                    );
                                                                }}
                                                            >
                                                                Visualizar
                                                            </Button>,
                                                        ]}
                                                    >
                                                        <List.Item.Meta
                                                            avatar={
                                                                <Avatar
                                                                    icon={<CloudSyncOutlined />}
                                                                    style={{
                                                                        backgroundColor: "#0e9c84",
                                                                    }}
                                                                />
                                                            }
                                                            title={
                                                                item.title
                                                            }
                                                            description={item.description} // Access description property
                                                        />
                                                    </List.Item>
                                                )}
                                            />
                                        ) : (
                                            <Empty description="Nada importado até o momento..." />
                                        )}
                                    </Col>
                                </Row>
                            </Modal>
                            <Modal
                                width={850}
                                title={
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <WarningOutlined
                                            style={{ marginRight: '8px', fontSize: '20px', color: '#faad14' }} />
                                        <span style={{ marginLeft: 'auto', marginRight: 'auto' }}>Você não pode excluir esse {(fieldOrFOrmCanNotDelete === 1) ? "campo" : "formulário"}!</span>
                                    </div>
                                }
                                closable={false}
                                cancelButtonProps={{ hidden: true }}
                                okText={"Confirmar"}
                                open={isModalCanNotDeleteVisible}
                                onOk={() => {
                                    setModalCanNotDeleteVisible(false);
                                    setFieldCanNotDelete(null);
                                    setFieldOrFOrmCanNotDelete(1);
                                }}>
                                <div>

                                    {(fieldOrFOrmCanNotDelete === 1) ?
                                        <p>Este campo está relacionado com outros campos de outros formulários. Para
                                            arquivar, você deve
                                            desfazer as relações antes de excluir esse campo!</p> :
                                        <p>Este formulário possui campo ou campos que estão relacionado com outros
                                            campos de outros formulários. Para arquivar, você deve
                                            desfazer as relações antes de excluir esse campo!</p>}

                                    {
                                        <Table columns={[
                                            {
                                                align: 'center',
                                                title: 'Campo deste Formulário',
                                                dataIndex: 'fieldOrigin',
                                                key: 'fieldOrigin',
                                                responsive: ['md'],
                                            },
                                            {
                                                align: 'center',
                                                title: 'Formulário de Relacionamento',
                                                dataIndex: 'form',
                                                key: 'form',
                                                render: (text, record) => (
                                                    <a href={`/formularios/detalhes/${text}`}
                                                        target={"_blank"}>{decodeURIComponent(text).replace("obj_", "")}</a>
                                                ),
                                                responsive: ['md'],
                                            },
                                            {
                                                align: 'center',
                                                title: 'Campo',
                                                dataIndex: 'field',
                                                key: 'field',
                                                responsive: ['md'],
                                            },
                                            {
                                                align: 'center',
                                                title: 'Tipo de Campo',
                                                dataIndex: 'fieldType',
                                                key: 'fieldType',
                                                render: (text, record) => {
                                                    return getFieldType(text)
                                                },
                                                responsive: ['md'],
                                            },
                                        ]} dataSource={fieldCanNotDelete} pagination={false} scroll={true} />
                                    }

                                </div>
                            </Modal>
                        </Skeleton>
                    </Layout>
                </Layout>
            </LayoutTopSide>
        </Fragment>)
    );
}
